/**
 * The legal documents' texts (ADR-0048): a namespace of its own, imported only by the legal page, so the long texts of
 * all three languages stay out of the main bundle and load with /legal/* only.
 */
import { defineNamespace } from "@prop/i18n";
import { useMemo } from "react";
import en from "./en/legal-docs";
import ru from "./ru/legal-docs";
import es from "./es/legal-docs";
import { useLang } from "./index";

const legalDocsT = defineNamespace(en, { ru, es });

export type LegalDoc = keyof typeof en;
/** The documents in reading order (the order of the legal page's navigation). */
export const LEGAL_DOCS = Object.keys(en) as LegalDoc[];

/** Section numbers of a document, from its EN source: every sNh key. */
export function legalSections(doc: LegalDoc): string[] {
  return Object.keys(en[doc])
    .map((k) => /^s(\d+)h$/.exec(k)?.[1])
    .filter((n): n is string => !!n);
}

export function useLegalDocsT() {
  const { lang } = useLang();
  return useMemo(() => legalDocsT.tFor(lang), [lang]);
}
